module.exports = __webpack_public_path__ + "assets/img/appstore-icon.7fb71410.svg";